<template>
  <f7-page>
    <f7-navbar :title="$t('title.budgetTransfer')" :back-link="$t('action.back')"/>
    <f7-list form>
      <f7-list-input :label="$t('label.from')"
                     type="select"
                     :value="fromBudgetId"
                     @input="fromBudgetId = parseInt($event.target.value)"
      >
        <option :value="0" disabled>{{$t('placeholder.chooseBudget')}}</option>
        <option v-for="budget in activeManagedBudgets" v-if="budget.potId !== toBudgetId" :key="budget.potId"
                :value="budget.potId"
        >
          {{budget.name}}
        </option>
      </f7-list-input>
      <f7-list-input :label="$t('label.amount')" :input="false">
        <div class="item-input-wrap" slot="input">
          <money v-model="amount" v-bind="money" maxlength="9"></money>
        </div>
      </f7-list-input>
      <f7-list-input :label="$t('label.to')"
                     type="select"
                     :value="toBudgetId"
                     @input="toBudgetId = parseInt($event.target.value)"
      >
        <option :value="0" disabled>{{$t('placeholder.chooseBudget')}}</option>
        <option v-for="budget in activeManagedBudgets" v-if="budget.potId !== fromBudgetId" :key="budget.potId"
                :value="budget.potId"
        >
          {{budget.name}}
        </option>
      </f7-list-input>
      <f7-block>
        <button type="submit" class="button button-big button-fill" @click.prevent="transfer">
          {{$t('action.transfer')}}
        </button>
      </f7-block>
    </f7-list>
  </f7-page>
</template>

<script>
  import api from 'aio-api'
  import helpers from '@/utils/helpers'

  export default {
    name: 'budget-transfer',
    async created () {
      this.$store.dispatch('budgets/fetch')
    },
    computed: {
      fromBudget () {
        return this.budgets.find(b => b.potId === this.fromBudgetId)
      },
      toBudget () {
        return this.budgets.find(b => b.potId === this.toBudgetId)
      },
    },
    data () {
      return {
        amount: 0,
        fromBudgetId: 0,
        toBudgetId: 0,
      }
    },
    methods: {
      async transfer () {
        const errors = []
        if (this.fromBudgetId === 0) errors.push(this.$t('validation.originBudget'))
        if (this.amount <= 0) errors.push(this.$t('validation.amount'))
        if (this.toBudgetId === 0) errors.push(this.$t('validation.destinationBudget'))
        if (errors.length > 0) this.$f7.dialog.alert(errors.join('<br>'), '')
        else {
          try {
            await api.postBudgetTransfer(this.fromBudgetId, this.toBudgetId, this.amount)
            this.$store.dispatch('budgets/fetch')
            this.$f7.dialog.alert(`You have transferred ${this.formatMoney(this.toBudget.currency, this.amount)} from "${this.fromBudget.name}" to "${this.toBudget.name}"`, '', this.goBack)
          } catch (error) {
            //TODO: i18n error message
            console.error(error)
            this.$f7.dialog.alert(error.response.data, '', this.goBack)
          }
        }
      },
    },
    mixins: [helpers],
    updated () {
      const fromBudgetId = parseInt(this.$f7route.params.from_budget_id)
      if (this.activeBudgets.find(b => b.potId === fromBudgetId) && this.fromBudgetId === 0) this.fromBudgetId = fromBudgetId
      const toBudgetId = parseInt(this.$f7route.params.to_budget_id)
      if (this.activeBudgets.find(b => b.potId === toBudgetId) && this.toBudgetId === 0) this.toBudgetId = toBudgetId
    },
  }
</script>

<style scoped>

</style>
